import React from "react";
import { PeriodPreset } from "../../../types/unit-economics.types";

const PRESET_OPTIONS: { value: PeriodPreset; label: string }[] = [
  { value: "last-28-days", label: "Ostatnie 28 dni" },
  { value: "last-90-days", label: "Ostatnie 90 dni" },
  { value: "last-365-days", label: "Ostatnie 365 dni" },
  { value: "last-month", label: "Poprzedni miesiąc (kalendarzowy)" },
  { value: "last-quarter", label: "Poprzedni kwartał (kalendarzowy)" },
  { value: "last-year", label: "Poprzedni rok (kalendarzowy)" },
  { value: "custom", label: "Własny zakres" },
];

interface PeriodSelectorProps {
  preset: PeriodPreset;
  customFrom: string; // YYYY-MM-DD
  customTo: string; // YYYY-MM-DD
  rangeError: string | null;
  onPresetChange: (p: PeriodPreset) => void;
  onCustomFromChange: (v: string) => void;
  onCustomToChange: (v: string) => void;
}

const PeriodSelector: React.FC<PeriodSelectorProps> = ({
  preset,
  customFrom,
  customTo,
  rangeError,
  onPresetChange,
  onCustomFromChange,
  onCustomToChange,
}) => {
  return (
    <div className="bg-white border border-neutral-200 rounded-lg p-4 space-y-4">
      <div className="flex flex-wrap items-center gap-6">
        {/* Preset */}
        <div className="flex items-center gap-2">
          <label
            htmlFor="ue-period-preset"
            className="text-sm font-medium text-neutral-700"
          >
            Okres:
          </label>
          <select
            id="ue-period-preset"
            value={preset}
            onChange={(e) => onPresetChange(e.target.value as PeriodPreset)}
            className="px-3 py-1.5 border border-neutral-300 rounded-md text-sm"
          >
            {PRESET_OPTIONS.map((option) => (
              <option key={option.value} value={option.value}>
                {option.label}
              </option>
            ))}
          </select>
        </div>
      </div>

      {/* Custom range */}
      {preset === "custom" && (
        <div className="flex flex-wrap items-end gap-4">
          <div>
            <label
              htmlFor="ue-custom-from"
              className="block text-xs font-medium text-neutral-600 mb-1"
            >
              Od
            </label>
            <input
              id="ue-custom-from"
              type="date"
              value={customFrom}
              max={customTo}
              onChange={(e) => onCustomFromChange(e.target.value)}
              className="px-3 py-1.5 border border-neutral-300 rounded-md text-sm"
            />
          </div>
          <div>
            <label
              htmlFor="ue-custom-to"
              className="block text-xs font-medium text-neutral-600 mb-1"
            >
              Do
            </label>
            <input
              id="ue-custom-to"
              type="date"
              value={customTo}
              min={customFrom}
              onChange={(e) => onCustomToChange(e.target.value)}
              className="px-3 py-1.5 border border-neutral-300 rounded-md text-sm"
            />
          </div>
          {rangeError && (
            <p role="alert" className="text-sm text-red-600 pb-1.5">
              {rangeError}
            </p>
          )}
        </div>
      )}
    </div>
  );
};

export default PeriodSelector;
